const DefaultCell = ({ value }) =>
  value !== null && value !== undefined ? String(value) : "—";

export default DefaultCell;
